var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignOutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89.6 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "exit-sign") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.4,68.67H40.29a7.23,7.23,0,0,1,0-14.45H66.4l-8.48-9.47a7.25,7.25,0,0,1,.51-10.16,7.07,7.07,0,0,1,10.05.51L87.76,56.62a7.27,7.27,0,0,1-.06,9.72L68.48,87.78a7.05,7.05,0,0,1-10.05.51,7.25,7.25,0,0,1-.51-10.16l8.48-9.46ZM40.11.14a7.22,7.22,0,0,1,2.83,14.17L39.55,15c-16.33,3.24-25.1,5.09-25.1,27.69V82.25c0,21,9.34,22.76,24.8,25.65l3.63.68a7.21,7.21,0,1,1-2.71,14.17l-3.57-.68C13.78,117.81,0,115.23,0,82.25V42.67C0,8.24,12.84,5.56,36.74.82L40.11.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutIcon);
export default __webpack_public_path__ + "static/media/sign-out-icon.d3bbe0b98c50a9122e42e8f2567286be.svg";
export { ForwardRef as ReactComponent };